import { localizationService } from "services/localization-service";

export const mainTourSteps = [
  {
    target: ".sidebar",
    placementBeacon: "top",
    placement: "right",
    disableBeacon: true,
    title: localizationService.getLocalizedString(
      "screen.tours.main.sidebar.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.sidebar.content"
    ),
  },
  {
    target: ".sidebar-assets",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.assets.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.assets.content"
    ),
  },
  {
    target: ".sidebar-events",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.events.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.events.content"
    ),
  },
  {
    target: ".sidebar-incidents",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.incidents.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.incidents.content"
    ),
  },
  {
    target: ".sidebar-actions",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.actions.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.actions.content"
    ),
  },
  {
    target: ".sidebar-monitoring",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.monitoring.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.monitoring.content"
    ),
  },
  {
    target: ".sidebar-dashboard",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.dashboard.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.dashboard.content"
    ),
  },
  {
    target: ".sidebar-map",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.map.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.map.content"
    ),
  },
  {
    target: ".sidebar-settings",
    placementBeacon: "right",
    placement: "right",
    title: localizationService.getLocalizedString(
      "screen.tours.main.settings.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.settings.content"
    ),
  },
  {
    target: ".help-menu",
    placementBeacon: "bottom",
    placement: "bottom",
    title: localizationService.getLocalizedString(
      "screen.tours.main.help.title"
    ),
    content: localizationService.getLocalizedString(
      "screen.tours.main.help.content"
    ),
  },
];
